<template>
  <div id="lastUpdate" class="pl-md-5 pr-md-5">
    <h5 class="ie-warning">
      <strong>
        IMPORTANT: If you are using Microsoft Internet Explorer, please consider
        <a href="https://www.microsoft.com/en-us/edge" target="_blank"
          >upgrading your browser</a
        >, as it has numerous compatibility and security issues, and is no
        longer supported by Microsoft.
      </strong>
      <br /><br />
    </h5>
    <p v-if="jsonLoaded">
      Note: AWOTE rates were last updated {{ awoteLastUpdatedUpdateText }}. The
      next expected update is {{ awoteNextExpectedUpdateText }}. This calculator
      will be temporarily unavailable on the day of the update.
    </p>
    <p>
      *Please
      <a
        href="https://www.csc.gov.au/Employers/Contact-us"
        target="parent"
        class="underln"
        >contact us</a
      >
      if you're calculating super salary for a CSS member whose salary reduction
      occurred before 1 July 2003.
    </p>
    <mdb-modal :show="loadingComplete && !jsonLoaded" centered>
      <mdb-modal-body class="text-center">
        The AWOTE calculator was unable to load some data.
        <br /><br />
        Please reload this page and try again, or if this error persists contact
        us.
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mdbModal, mdbModalBody } from "mdbvue";

export default {
  name: "LastUpdate",
  components: {
    mdbModal,
    mdbModalBody
  },
  computed: {
    ...mapGetters([
      "loadingComplete",
      "jsonLoaded",
      "awoteLastUpdatedUpdateText",
      "awoteNextExpectedUpdateText"
    ])
  }
};
</script>

<style scoped>
p {
  color: #999;
  font-size: 0.85em;
}
</style>
